import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import PagamentosService from "../../../services/PagamentosService";
import ETTService from "../../../services/ETTService";
import EmpresaGloboService from "../../../services/EmpresaGloboService";
import moment from "moment/moment";
import {formatarDataISO8601} from "../../../utils/formatar";

export default class LotesPagamentoStore {

    @observable filtros;
    @observable momentDataInicioFiltro;
    @observable momentDataFimFiltro;
    @observable dataInicioFiltroValidacao;
    @observable dataFimFiltroValidacao;
    @observable lotesLista;
    @observable loading;
    @observable loadingEtts;
    @observable loadingEmpresasGlobo;
    @observable empresasGlobo;
    @observable etts;
    @observable carregando;

    constructor(props) {
        this.loading = false;
        this.loadingEtts = false;
        this.loadingEmpresasGlobo = false;
        this.lotesLista = [];
        this.pagamentoService = new PagamentosService();
        this.ettService = new ETTService();
        this.empresaGloboService = new EmpresaGloboService();
        this.resetFiltros();

        this.empresasGlobo = [];
        this.etts = [];
        this.carregando = false;
    }

    resetFiltros = () => {
        this.filtros = {
            empresaGloboIds: '',
            dataInicio: null,
            dataFim: null,
            status: '',
            ettIds: ''
        }
    };

    carregarDadosDaUrl = (params) => {
        extendObservable(this.filtros, params);
        this.carregarDadosDataInicioUrl(params);
        this.carregarDadosDataFimUrl(params);
        this.carregarTabela();
    };

    carregarDadosDataInicioUrl = (params) => {
        if(params && params.dataInicio) {
            this.momentDataInicioFiltro = moment(params.dataInicio, "DD-MM-YYYY");
        }
    };

    carregarDadosDataFimUrl = (params) => {
        if(params && params.dataFim) {
            this.momentDataFimFiltro = moment(params.dataFim, "DD-MM-YYYY");
        }
    };

    carregarDados = () => {
        this.carregarETTs();
        this.carregarEmpresasGlobo();
    };

    carregarTabela = () => {
        this.loading = true;
        const loadingPromises = Promise.all([
            this.pagamentoService.listarLotes(_.pickBy(this.filtros, _.identity)).then(response => {
                if(response.data) {
                    for(let lote of response.data) {
                        if(lote.notasFiscais) {
                            const dataEmissaoNotasFiscais = lote.notasFiscais.map(n => formatarDataISO8601(n.dataEmissao));
                            const numeroNotasFiscais = lote.notasFiscais.map(n => n.numero);
                            lote.numeroNotasFiscais = numeroNotasFiscais.join("<br>");
                            lote.dataEmissaoNotasFiscais = dataEmissaoNotasFiscais.join("<br>");
                        }
                    }
                }
                this.lotesLista = response.data;
            }).catch(error => {
                console.log(error);
            })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    };

    setLista = (value) => {
        this.lotesLista = value;
    };

    setEmpresaGlobo = (value, options) => {
        this.filtros.empresaGloboIds = value;
    };

    setETT = (value, options) => {
        this.filtros.ettIds = value;
    };

    setStatus = (value, options) => {
        this.filtros.status = value;
    };

    setMomentDataInicioFiltro = (value) => {
        if(value) {
            let startDate = value;
            startDate = moment(startDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            let endDate = this.momentDataFimFiltro;
            if (endDate != null && endDate.length !== 0 && startDate != null && startDate.length !== 0 && startDate.isAfter(endDate)) {
                endDate = null
            }
            this.momentDataInicioFiltro = startDate;
            if (startDate != null && startDate.length !== 0) {
                this.filtros.dataInicio = startDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataInicio = null;
            }
            this.momentDataFimFiltro = endDate;
            if (endDate != null && endDate.length !== 0) {
                this.filtros.dataFim = endDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataFim = null;
            }
            this.dataInicioValidacao =  moment(value).format('DD/MM/YYYY');
        } else {
            this.filtros.dataInicio = null;
            this.momentDataInicioFiltro = null;
            this.dataInicioFiltroValidacao = null;
        }
    };

    setDataInicioCheck = (value) => {
        this.dataInicioFiltroValidacao = value;
        if(!value) {
            this.filtros.dataInicio = "";
            this.dataInicioFiltroValidacao = null;
        }
    };

    setMomentDataFimFiltro = (value) => {
        if(value) {
            let startDate = this.momentDataInicioFiltro;
            let endDate = value;
            endDate = moment(endDate.format('DD/MM/YYYY'), "DD/MM/YYYY");
            if (endDate != null && endDate.length !== 0 && startDate != null && startDate.length !== 0 && startDate.isAfter(endDate)) {
                startDate = null;
            }
            this.momentDataInicioFiltro = startDate;
            if (startDate != null && startDate.length !== 0) {
                this.filtros.dataInicio = startDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataInicio = null;
            }
            this.momentDataFimFiltro = endDate;
            if (endDate != null && endDate.length !== 0) {
                this.filtros.dataFim = endDate.format('DD-MM-YYYY');
            }
            else {
                this.filtros.dataFim = null;
            }
            this.dataFimFiltroValidacao = moment(value).format('DD/MM/YYYY');
        } else {
            this.filtros.dataFim = null;
            this.momentDataFimFiltro = null;
            this.dataFimFiltroValidacao = null;
        }
    };

    setDataFimCheck = (value) =>{
        this.dataFimFiltroValidacao = value;
        if(!value) {
            this.filtros.dataFim = "";
            this.dataFimFiltroValidacao = null;
        }
    };

    carregarEmpresasGlobo = ()=> {
        this.loadingEmpresasGlobo = true;
        return this.empresaGloboService.list().then(response => {
            this.empresasGlobo = response.data
            this.loadingEmpresasGlobo = false;
        }).catch(error => {
            this.loadingEmpresasGlobo = false;
            console.log(error);
        });
    };

    carregarETTs = () => {
        this.loadingEtts = true;
        return this.ettService.list().then(response => {
            this.etts = response.data;
            this.loadingEtts = false;
        }).catch(error => {
            this.loadingEtts = false;
            console.log(error);
        });
    };

    @action
    displayButton(row) {
        if(row) {
            let form = Object.assign({}, row);
            //Pendente = 1
            //TODO: realizar a busca por enumerados
            if(form.status === "ERR")
                return "";
            else
                return "none";
        }
    }

    reenviarLotePagamento = (id) => {
        this.carregando = true;
        return this.pagamentoService.reenviarLotePagamento(id).then(response => {
            //atualizar a listagem
            this.carregarTabela();
            this.carregando = false;
        }).catch(error => {
            //this.loadingEmpresasGlobo = false;
            console.log(error);
        });
    }

    // Método para aplicar filtros e carregar dados
    aplicarFiltros = () => {
        this.carregarTabela();
    };

}